<template>
    <div class="ciclo-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="700" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="cicloForm" v-model="validCiclo">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="cicloItem.nombre"
                                                label="Nombre*"
                                                :rules="nombreFieldRules"
                                                :error-messages="nombreFieldErrors"
                                                :counter="255"
                                                @keydown="nombreFieldErrors = []"
                                                @keypress.enter="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="cicloItem.descripcion"
                                                label="Descripción"
                                                :counter="255"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-menu
                                                ref="menuFechaInicio"
                                                v-model="menuFechaInicio"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="computedFechaInicioFormatted"
                                                        label="Fecha Inicio*"
                                                        v-on="on"
                                                        readonly
                                                        :rules="fecha_inicioFieldRules"
                                                        :error-messages="fecha_inicioFieldErrors"
                                                        @blur="dateFecha_inicio = parseDate(cicloItem.fecha_inicio)"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateFecha_inicio"
                                                    no-title
                                                    scrollable
                                                    locale="es-es"
                                                    type="month"
                                                    @input="menuFechaInicio = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-menu
                                                ref="menuFechaFin"
                                                v-model="menuFechaFin"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="computedFechaFinFormatted"
                                                        label="Fecha Fin*"
                                                        v-on="on"
                                                        readonly
                                                        :rules="fecha_finFieldRules"
                                                        :error-messages="fecha_finFieldErrors"
                                                        @blur="dateFecha_fin = parseDate(cicloItem.fecha_fin)"
                                                    >
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dateFecha_fin"
                                                    no-title
                                                    scrollable
                                                    type="month"
                                                    locale="es-es"
                                                    @input="menuFechaFin = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
    export default {
        props: {
            formTitle: String,
            initialItem: Object
        },
        data () {
            return {
                loading: false,
                validCiclo: false,
                cicloItem: {
                    descripcion: '',
                    nombre: '',
					fecha_inicio: this.formatDate(new Date().toISOString().substr(0, 10)),
					fecha_fin: this.formatDate(new Date().toISOString().substr(0, 10)),
                },
				dateFecha_inicio: new Date().toISOString().substr(0, 10),
				dateFecha_fin: new Date().toISOString().substr(0, 10),

				//menus de fecha
				menuFechaInicio: false,
				menuFechaFin: false,

                //validaciones
                nombreFieldRules: [
                    v => !!v || 'Debe proporcionar un nombre',
                    v => v.length <= 255 || 'El nombre solo puede contener 255 caracteres',
                ],
                nombreFieldErrors: [],
				fecha_inicioFieldRules: [
					v => !!v || 'Debe proporcionar la fecha de inicio'
				],
				fecha_inicioFieldErrors: [],
				fecha_finFieldRules: [
					v => !!v || 'Debe proporcionar la fecha de fin'
				],
				fecha_finFieldErrors: [],
                //ToDo: validar que la fecha de inicio y fin no pueden ser iguales
            }
        },
        computed: {
			computedFechaInicioFormatted () {
				return this.formatDate(this.dateFecha_inicio)
			},

			computedFechaFinFormatted () {
				return this.formatDate(this.dateFecha_fin)
			},

            isNewRecord() {
                return this.initialItem === null
            },

            showForm: {
                get: function() {
                    return true
                },
                set: function () {
                    return this.cancelForm()
                }
            },

            disableSaveButton() {
                return this.loading || (!this.validCiclo)
            }
        },

        methods:{
            saveForm() {
                this.loading = true
                this.$refs.cicloForm.validate()
                if (this.validCiclo) {
					let ciclo = {}

                    const a_inicio = this.cicloItem.fecha_inicio.split('/')[1]
                    const a_fin = this.cicloItem.fecha_fin.split('/')[1]
					const m_inicio = this.cicloItem.fecha_inicio.split('/')[0]
					const m_fin = this.cicloItem.fecha_fin.split('/')[0]

                    ciclo.nombre = this.cicloItem.nombre
                    ciclo.descripcion = this.cicloItem.descripcion
                    ciclo.mes_inicio = m_inicio
                    ciclo.anyo_inicio = a_inicio
                    ciclo.mes_fin = m_fin
                    ciclo.anyo_fin = a_fin

                    if (!this.isNewRecord) {
						ciclo.id = this.initialItem.id
					}

					this.$store.dispatch(this.isNewRecord ? "ADD_CICLO" : "UPDATE_CICLO", ciclo).then(
                        result => {
                        	if (!result) {//no hay coneccion con el servidor
                        		this.loading = false
                            }
                            if (result === null || result.status === 404 || result.status === 500) {
                                //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                                this.$emit("formCanceled")
                            } else {
                                // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                                let { data, status } = result
                                if (status === 422) {
                                    data.forEach(error => {
										switch (error.field) {
											case "mes_inicio":
												this.fecha_inicioFieldErrors.push(error.message)
												break
											case "anyo_inicio":
												this.fecha_inicioFieldErrors.push(error.message)
												break
											case "mes_fin":
												this.fecha_finFieldErrors.push(error.message)
												break
											case "anyo_fin":
												this.fecha_finFieldErrors.push(error.message)
												break
											case "nombre":
												this.nombreFieldErrors.push(error.message)
												break
											default: console.log(error.message)
										}
                                    })
                                }
                            }
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            },
            cancelForm() {
                this.$emit("formCanceled")
            },
			formatDate (date) {
				if (!date) return null

				const [year, month, day] = date.split('-')
				return `${month}/${year}`
			},

			parseDate (date) {
				if (!date) return null

				const [month, year] = date.split('/')
				return `${year}-${month.padStart(2, '0')}-01`
			}
        },
		watch: {
			dateFecha_inicio: function() {
				this.cicloItem.fecha_inicio = this.formatDate(this.dateFecha_inicio)
			},
			dateFecha_fin: function() {
				this.cicloItem.fecha_fin = this.formatDate(this.dateFecha_fin)
			}
		},
        created() {
            if (this.initialItem !== null) {
                // Cargando información del elemento a actualizar
                this.cicloItem.nombre = this.initialItem.nombre
                this.cicloItem.descripcion = this.initialItem.descripcion
                this.cicloItem.fecha_inicio = this.initialItem.mes_inicio + '/' + this.initialItem.anyo_inicio
                this.cicloItem.fecha_fin = this.initialItem.mes_fin + '/' + this.initialItem.anyo_fin
				this.dateFecha_inicio = this.initialItem.anyo_inicio + '-' + this.initialItem.mes_inicio + '-01'
				this.dateFecha_fin = this.initialItem.anyo_fin + '-' + this.initialItem.mes_fin + '-01'
            }
        },
    }
</script>
